import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { reduxBatch } from '@manaflair/redux-batch'

import { getChachedState, cacheStateMidleware } from './cacheState'
import configReducer, { CONFIG_REDUCER_KEY } from './configSlice'
import mapSlice, { MAP_REDUCER_KEY } from './mapSlice'
import transportSlice, { TRANSPORT_REDUCER_KEY, transportsMiddleware } from './transportSlice'
import filterSlice, { FILTER_REDUCER_KEY, filterMiddleware } from './filterSlice'

const rootReducer = combineReducers({
    [CONFIG_REDUCER_KEY]: configReducer,
    [MAP_REDUCER_KEY]: mapSlice,
    [TRANSPORT_REDUCER_KEY]: transportSlice,
    [FILTER_REDUCER_KEY]: filterSlice,
})

const store = configureStore({
    preloadedState: getChachedState(),
    reducer: rootReducer,
    middleware: [
        ...getDefaultMiddleware(),
        transportsMiddleware,
        filterMiddleware,
        cacheStateMidleware,
    ],
    enhancers: [reduxBatch],
})

export default store
